var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-dialog-v2',{attrs:{"dialog":_vm.addOperatorDialog},on:{"enter":_vm.saveOperatorName}})}
var staticRenderFns = []

export { render, staticRenderFns }